const CANVA_EDITOR_OPENED_KEY = "moxie.canvaEditorOpenedAt";
export const CANVA_SYNC_CHANNEL = "moxie-canva-sync";
export const CANVA_EDITOR_OPENED_EVENT = "moxie-canva-editor-opened";

export type CanvaSyncMessage =
	| {
			type: "canva-import";
			importId: number;
	  }
	| {
			type: "canva-editor-opened";
	  };

export function markCanvaEditorOpened(): void {
	sessionStorage.setItem(CANVA_EDITOR_OPENED_KEY, String(Date.now()));
	window.dispatchEvent(new Event(CANVA_EDITOR_OPENED_EVENT));
	broadcastCanvaEditorOpened();
}

export function clearCanvaEditorOpened(): void {
	sessionStorage.removeItem(CANVA_EDITOR_OPENED_KEY);
}

export function wasCanvaEditorOpened(): boolean {
	return sessionStorage.getItem(CANVA_EDITOR_OPENED_KEY) !== null;
}

export function parseCanvaImportId(raw: string | null): number | null {
	if (!raw) {
		return null;
	}
	const id = Number(raw);
	return Number.isInteger(id) && id > 0 ? id : null;
}

function postCanvaSyncMessage(message: CanvaSyncMessage): void {
	try {
		const channel = new BroadcastChannel(CANVA_SYNC_CHANNEL);
		channel.postMessage(message);
		channel.close();
	} catch {
		// BroadcastChannel is unavailable in some browsers / private modes.
	}
}

export function broadcastCanvaImport(importId: number): void {
	postCanvaSyncMessage({ type: "canva-import", importId });
}

export function broadcastCanvaEditorOpened(): void {
	postCanvaSyncMessage({ type: "canva-editor-opened" });
}
